import { styled } from '@mui/material'
import { FC } from 'react'
import { PhotoView } from 'react-photo-view'

const StyledImg = styled('img')<{ isDoneLoading: boolean; isAssistant: boolean }>(
    ({ theme, isDoneLoading, isAssistant }) => ({
        background: isDoneLoading ? 'red' : '',
        borderRadius: '32px',
        maxWidth: isAssistant ? '356px' : '247px',
        maxHeight: isAssistant ? '356px' : '247px',
        display: isDoneLoading ? 'flex' : 'none',
        objectFit: 'cover',
        [theme.breakpoints.down('sm')]: {
            maxWidth: isAssistant ? '279px' : '149px',
        },
        cursor: 'pointer',
    }),
)

type Props = {
    src: string
    isDoneLoading: boolean
    isAssistant: boolean
    onLoad?: VoidFunction
    onError?: VoidFunction
}

export const Image: FC<Props> = ({ src, isAssistant, isDoneLoading, onError, onLoad }) => (
    <PhotoView src={src}>
        <StyledImg
            isDoneLoading={isDoneLoading}
            isAssistant={isAssistant}
            onLoad={onLoad}
            onError={onError}
            src={src}
        />
    </PhotoView>
)
